import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Cursor } from "@/components/Cursor";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Galerie from "@/pages/Galerie";
import Momente from "@/pages/Momente";
import { setLenis } from "@/lib/scroll";
import "@/App.css";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/momente" element={<Momente />} />
        </Routes>
        <Cursor />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#18181D",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#F7F7F8",
            borderRadius: "4px",
          },
        }}
      />
    </div>
  );
}

export default App;
